module.exports = __webpack_public_path__ + "img/7.d163af63.png";